/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_COSTUME_VALUE } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface UpdateInventoryProps {
  id: string;
  inventory: number;
}

export interface IUpdateInventoryMethods extends IPluginMethodMap {
  updateInventory(args: UpdateInventoryProps): Promise<any>;
}

export class UpdateInventoryService implements IAgentPlugin {
  readonly methods: IUpdateInventoryMethods;

  constructor() {
    this.methods = {
      updateInventory: this.updateInventory.bind(this),
    };
  }

  async updateInventory(args: UpdateInventoryProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: UPDATE_COSTUME_VALUE,
          variables: {
            filter: {
              _id: args?.id,
            },
            update: {
              inventory: args?.inventory,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateCostumeValue,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
